import React from 'react';
import { useTenant } from '../TenantProvider';
import { Building2 } from 'lucide-react';

/**
 * Full-screen company picker for multi-tenant selection.
 * - Reads company list from TenantProvider
 * - Calls setActiveCompany() when a company card is clicked
 * - Closes via onClose()
 */
export default function CompanySelector({ onClose }) {
  const { companies, setActiveCompany } = useTenant();

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-6">
      <div className="w-full max-w-5xl bg-slate-900 border border-slate-700 rounded-2xl shadow-2xl">
        {/* Header */}
        <div className="px-6 py-4 border-b border-slate-800 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-slate-100">Select a Company</h3>
          <button
            className="text-slate-400 hover:text-slate-200"
            onClick={onClose}
            aria-label="Close selector"
          >
            ✕
          </button>
        </div>

        {/* Grid */}
        <div className="p-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {companies?.length ? (
            companies.map((c) => (
              <button
                key={c.numeric_id}
                onClick={() => {
                  setActiveCompany(c);  // persists to localStorage via TenantProvider
                  onClose?.();
                }}
                className="w-full p-4 bg-slate-800/30 hover:bg-slate-800/50
                           border border-slate-700/50 hover:border-cyan-500/50
                           rounded-xl transition-all text-left"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center">
                    <Building2 className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <div className="text-slate-100 font-medium">{c.name}</div>
                    <div className="text-xs text-slate-400 font-mono">{c.id}</div>
                  </div>
                </div>
                <div className="mt-3 text-xs text-slate-500">
                  Tier: {c.subscription_tier || '—'}
                  {c.active === false ? ' • (inactive)' : ''}
                </div>
              </button>
            ))
          ) : (
            <div className="col-span-full text-slate-400 text-sm">
              No companies available for your account.
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-slate-800 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg text-sm text-slate-100"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
